module.exports = __webpack_public_path__ + "static/img/footer__logo.b471efec.svg";